export const PICKUP_STATUS = {
  WAITING: 'waiting',
  PENDING: 'pending',
  ACTIVE: 'active',
} as const;
